export default class RichMetadata {
    findEnvironment(name) {
        // debugger;
        console.log({
            ...APP.metadata.Environment[name],
            name: name
        });
        return {
            ...APP.metadata.Environment[name],
            name: name
        }
    }
}